exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scope-set-min-height[data-v-8fb080d4]{min-height:40vh}.scope-border-simple[data-v-8fb080d4]{border:1px solid #cfcfcf}.scope-overflow-scroll[data-v-8fb080d4]{overflow:scroll;height:100%;width:100%}.scope-preview[data-v-8fb080d4]{margin:15px 5px;padding:2rem;border:3px double #dfdfdf;min-height:20vh;resize:vertical;overflow:auto}.scope-contains-ckeditor[data-v-8fb080d4]{min-height:10rem}", ""]);

// exports
